import axios from 'axios';
import { API_URL } from './api';

// ВАЖНО: префикс, под которым admins.urls подключён в корневом urlconf.
// Если admins подключён иначе (напр. '/dashboard' или '/admins') — поправьте здесь.
export const ADMIN_API_BASE = `${API_URL}/api/admin-panel`;

export const adminAuthConfig = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  },
});

const handle = (error) => {
  if (error.response) {
    console.error('Admin API error:', error.response.status, error.response.data);
  } else {
    console.error('Admin API error:', error.message);
  }
};

// ---------------- Параметры (traits) ----------------
export const APIAdminTraitsList = async (token) => {
  try {
    const r = await axios.get(`${ADMIN_API_BASE}/traits/`, adminAuthConfig(token));
    return r.data; // { success, items: [...] }
  } catch (e) { handle(e); throw e; }
};

export const APIAdminTraitCreate = async (token, data) => {
  try {
    const r = await axios.post(`${ADMIN_API_BASE}/traits/create/`, data, adminAuthConfig(token));
    return r.data;
  } catch (e) { handle(e); throw e; }
};

export const APIAdminTraitUpdate = async (token, traitId, data) => {
  try {
    const r = await axios.patch(`${ADMIN_API_BASE}/traits/${traitId}/`, data, adminAuthConfig(token));
    return r.data;
  } catch (e) { handle(e); throw e; }
};

export const APIAdminTraitDelete = async (token, traitId) => {
  try {
    const r = await axios.delete(`${ADMIN_API_BASE}/traits/${traitId}/delete/`, adminAuthConfig(token));
    return r.data;
  } catch (e) { handle(e); throw e; }
};

// ---------------- Тесты ----------------
export const APIAdminQuizzesList = async (token) => {
  try {
    const r = await axios.get(`${ADMIN_API_BASE}/quizzes/`, adminAuthConfig(token));
    return r.data; // { success, items: [...] }
  } catch (e) { handle(e); throw e; }
};

export const APIAdminQuizDetail = async (token, quizId) => {
  try {
    const r = await axios.get(`${ADMIN_API_BASE}/quizzes/${quizId}/`, adminAuthConfig(token));
    return r.data; // { success, quiz: {...} }
  } catch (e) { handle(e); throw e; }
};

export const APIAdminQuizCreate = async (token, data) => {
  try {
    const r = await axios.post(`${ADMIN_API_BASE}/quizzes/create/`, data, adminAuthConfig(token));
    return r.data; // { success, id }
  } catch (e) { handle(e); throw e; }
};

export const APIAdminQuizUpdate = async (token, quizId, data) => {
  try {
    const r = await axios.patch(`${ADMIN_API_BASE}/quizzes/${quizId}/update/`, data, adminAuthConfig(token));
    return r.data;
  } catch (e) { handle(e); throw e; }
};

export const APIAdminQuizDelete = async (token, quizId) => {
  try {
    const r = await axios.delete(`${ADMIN_API_BASE}/quizzes/${quizId}/delete/`, adminAuthConfig(token));
    return r.data;
  } catch (e) { handle(e); throw e; }
};

export const APIAdminQuizBulkUpdate = async (token, quizId, payload) => {
  try {
    const r = await axios.post(`${ADMIN_API_BASE}/quizzes/${quizId}/bulk-update/`, payload, adminAuthConfig(token));
    return r.data; // { success, quiz: {...} }
  } catch (e) { handle(e); throw e; }
};

export const APIAdminQuizStats = async (token, quizId) => {
  try {
    const r = await axios.get(`${ADMIN_API_BASE}/quizzes/${quizId}/stats/`, adminAuthConfig(token));
    return r.data; // { success, stats: {...} }
  } catch (e) { handle(e); throw e; }
};